export default __webpack_public_path__ + "e8d3368de9f2e3aed4a8f8843abaaf85.png";